import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "class-group"
};
import IframeContainer from '@/components/IframeContainer/index.vue';
var url = 'https://report.zhixuehuijiao.cn/webroot/decision/view/duchamp?viewlet=class_group%252Fclass_group.fvs';
export default {
  __name: 'ClassGroup',
  setup: function setup(__props) {
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(IframeContainer, {
        src: url
      })]);
    };
  }
};